import { render } from "./SetPassword.vue?vue&type=template&id=a9768f1c&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"

import "./SetPassword.vue?vue&type=style&index=0&id=a9768f1c&scoped=true&lang=css"
import "./SetPassword.vue?vue&type=style&index=1&id=a9768f1c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9768f1c"]])

export default __exports__